import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { Bell, Check, Star } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function ReviewNotifications() {
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);
  const nav = useNavigate();

  const load = () => api.get("/review-notifications?unread_only=true").then(r => {
    setItems(r.data.items); setUnread(r.data.unread);
  });
  useEffect(() => { load(); }, []);

  if (unread === 0) return null;

  const markRead = async (id, e) => {
    e.stopPropagation();
    try { await api.patch(`/review-notifications/${id}/read`); load(); toast.success("Als gelesen markiert"); }
    catch { toast.error("Fehler"); }
  };

  return (
    <div className="msb-card border-l-4 border-l-amber-500" data-testid="dashboard-review-notifications">
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-2">
          <Bell size={20} weight="duotone" className="text-amber-500"/>
          <div>
            <div className="font-semibold" style={{fontFamily:"'Work Sans',sans-serif"}}>
              {unread} neue Bewertung{unread > 1 ? "en" : ""}
            </div>
            <div className="text-xs text-muted-foreground">Zum Lesen abhaken oder öffnen</div>
          </div>
        </div>
        <Button variant="outline" size="sm" onClick={()=>nav("/bewertungen")} className="rounded-xl" data-testid="open-reviews-btn">
          Alle ansehen
        </Button>
      </div>
      <div className="mt-3 space-y-2">
        {items.slice(0, 3).map(n => (
          <div key={n.id} className="flex items-start justify-between gap-3 p-3 rounded-xl bg-muted/40 hover:bg-muted/60 transition-colors cursor-pointer"
               onClick={()=>nav("/bewertungen")}
               data-testid={`dashboard-review-${n.id}`}>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 text-sm">
                <span className="font-semibold" style={{color: n.platform === "Booking.com" ? "#003580" : n.platform === "Google" ? "#4285F4" : n.platform === "Airbnb" ? "#FF5A5F" : "#00AA6C"}}>
                  {n.platform}
                </span>
                {n.rating != null && (
                  <span className="inline-flex items-center gap-1 text-xs">
                    <Star size={12} weight="fill" className="text-amber-500"/>
                    <span className="font-medium">{String(n.rating).replace(".", ",")}/{n.scale}</span>
                  </span>
                )}
                {n.author && <span className="text-xs text-muted-foreground truncate">· {n.author}</span>}
              </div>
              <div className="text-sm mt-1 line-clamp-2 text-foreground/80">{n.text}</div>
            </div>
            <Button size="sm" variant="outline" onClick={(e)=>markRead(n.id, e)} className="rounded-lg shrink-0" data-testid={`dashboard-mark-read-${n.id}`}>
              <Check size={14} weight="bold"/>
            </Button>
          </div>
        ))}
        {items.length > 3 && (
          <div className="text-xs text-center text-muted-foreground">+ {items.length - 3} weitere</div>
        )}
      </div>
    </div>
  );
}
